module.exports = __webpack_public_path__ + "static/media/option1-4row.0d91b9b3.png";